import { useEffect, useState } from 'react';

export function useViewport() {
  const [size, setSize] = useState(() => ({ width: typeof window !== 'undefined' ? window.innerWidth : undefined, height: typeof window !== 'undefined' ? window.innerHeight : undefined }));
  useEffect(() => {
    const handler = () => setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return size;
}
